import { Util } from "@grandvisionhq/common";
const imageSizes = {
  M: 171,
  L: 192,
  XL: 272,
  MAX: 544
};
function createResponsiveImage(imageUrl, alt, params) {
  const settings = {
    fit: "fill",
    format: "jpeg",
    aspectRatio: 16 / 9,
    ...params
  };
  return {
    url: Util.createImgUrl(imageUrl, settings),
    alt,
    srcSet: Util.createImageSrcSet(imageUrl, imageSizes, settings),
    sizes: Util.createImageSizes(imageSizes, imageUrl)
  };
}
export {
  createResponsiveImage,
  imageSizes
};
//# sourceMappingURL=create-responsive-image.js.map
